export default {
  TvOffer: {
    DESC: "tv-desc",
    OFFER: "tv",
    PROGRAM: "tv-program",
    PRICING: "tv-pricing",
    PRICING_FOOTER: "tv-pricing-footer"
  },

  InternetOffer: {
    DESC: "internet-desc",
    OFFER: "internet",
    PRICING: "internet-pricing",
    PRICING_FOOTER: "internet-pricing-footer"
  },

  Contact: {
    OFFICES: "offices",
    FOOTER: "contact-footer",
    BREAKDOWN_HEADER: "contact-breakdown-header",
    BREAKDOWN: "contact-breakdown"
  },

  Footer: {
    TITLE: "footer-title",
    ADDRESS: "footer-address",
    DESC: "footer-desc",
    PHONE: "footer-phone",
    MAIL: "footer-mail"
  },

  Privacy: {
    CONTENT: "privacy-content"
  },

  Gdpr: {
    CONTENT: "gdpr-content"
  }
};
